<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-container v-show="Details">
        <v-card style="border: 1px solid">
          <v-toolbar :color="appColor">
            <v-card-title class="headline mb-1">
              <span style="color:white"> Export รายชื่อผู้เข้าร่วมโครงการ</span>
            </v-card-title>
          </v-toolbar>
          <v-list-item>
            <v-row>
              <v-col cols="12">
                <v-expand-transition>
                  <v-card v-if="!Details_Cordi" style="border: 1px solid">
                    <v-list>
                      <v-list-item class="justify-center">
                        <div align="center">
                          <p class="font-weight-bold">เลือกปีงบประมาณก่อนทำรายการ</p>
                        </div>
                      </v-list-item>
                      <v-list-item class="justify-center">
                        <v-radio-group row v-model="FiscalYear" v-for="fiscalYear in FiscalYearDataSel"
                          :key="fiscalYear.year" @change="selProjFiscalYear">
                          <v-radio :value="fiscalYear.year" class="font-weight-bold"
                            :label="('' + fiscalYear.yearth)"></v-radio>
                        </v-radio-group>
                      </v-list-item>
                      <v-list-item>
                        <v-row justify="center" class="d-flex justify-center">
                          <v-col cols="12" md="12">
                            <v-card-title>
                              ตารางข้อมูลรายละเอียดโครงการ
                              <v-spacer></v-spacer>
                              <v-text-field v-model="search" append-icon="mdi-magnify"
                                label="ค้นหา รหัสโครงการ, โครงการ" single-line hide-details></v-text-field>
                            </v-card-title>
                          </v-col>
                        </v-row>
                      </v-list-item>
                      <!-- <v-list-item class="d-flex justify-center">
                        <v-radio-group row v-model="TypeInsertProject">
                          <v-radio value="1" class="font-weight-bold"
                            label="ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"></v-radio>
                          <v-radio value="0" class="font-weight-bold"
                            label="ไม่ผ่านการเสนอแผนขอตั้งงบประมาณประจำปี"></v-radio>
                        </v-radio-group>
                      </v-list-item> -->
                      <v-list-item>
                        <v-row justify="center" class="justify-center">
                          <v-col cols="12" md="12">

                            <!--                        @click:row="GetData"-->
                            <v-data-table :headers="courseHeaders"
                              :items="projectRegDataDump.filter(item => (TypeInsertProject == '1' ? item.Approve == '1' : item.Approve == '0'))"
                              :search="search" item-key="D_Project_Register_id" :single-expand="singleExpand"
                              :expanded.sync="expanded" class="elevation-1">
                              <template v-slot:header.full_Name>
                                <v-label fontSize="16px" fontWeight="bold">
                                  โครงการ
                                </v-label>
                              </template>
                              <!-- <template v-slot:header.round>
                                <v-label fontSize="16px" fontWeight="bold">
                                  รอบที่
                                </v-label>
                              </template>
                              <template v-slot:header.round_name>
                                <v-label fontSize="16px" fontWeight="bold">
                                  ชื่อรอบ
                                </v-label>
                              </template> -->
                              <template v-slot:header.dateReg>
                                <v-label fontSize="16px" fontWeight="bold">
                                  วันที่เริ่มต้น
                                </v-label>
                              </template>
                              <template v-slot:header.dateEndReg>
                                <v-label fontSize="16px" fontWeight="bold">
                                  วันที่สิ้นสุด
                                </v-label>
                              </template>
                              <template v-slot:header.time_start>
                                <v-label fontSize="16px" fontWeight="bold">
                                  เวลาเริ่ม
                                </v-label>
                              </template>
                              <template v-slot:header.time_end>
                                <v-label fontSize="16px" fontWeight="bold">
                                  เวลาสิ้นสุด
                                </v-label>
                              </template>
                              <template v-slot:item.full_Name="{ item }">
                                <div v-html="item.full_Name"></div>
                                <div style="margin-top: -12px; color: #364eff;">
                                  <template v-if="item.round">
                                  <span>รอบที่ {{ item.round }}</span>
                                  </template>
                                  <template v-if="item.round_name">
                                  <span v-if="item.round"> | </span>
                                  <span>ชื่อรอบ {{ item.round_name }}</span>
                                  </template>
                                </div>
                              </template>
                              <template v-slot:item.dateReg="{ item }">
                                {{ item.dateReg | dateToThai }}
                              </template>
                              <template v-slot:item.dateEndReg="{ item }">
                                {{ item.dateEndReg | dateToThai }}
                              </template>
                              <template v-slot:item.time_start="{ item }">
                                <span v-if="item.time_start != '00:00:00'">{{ item.time_start }}</span>
                                <span v-else> - </span>
                              </template>
                              <template v-slot:item.time_end="{ item }">
                                <span v-if="item.time_end != '00:00:00'">{{ item.time_end }}</span>
                                <span v-else> - </span>
                              </template>
                              <template v-slot:item.Project_Details="{ item }">
                                <v-btn text class="darken-3" color="green" @click="showDetails(item)">
                                  แสดงรายละเอียด
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-expand-transition>
              </v-col>
            </v-row>
          </v-list-item>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-col cols="12" md="12">
                <template v-if="Details_Cordi">

                  <v-list-item>
                    <v-btn outlined color="#FF5722" @click="showDetails">
                      ย้อนกลับ
                    </v-btn>
                  </v-list-item>

                  <v-card class="justify-center pa-6 mt-7">
                    <v-card-title color="primary" style="background-color: burlywood">
                      <div v-html="project.full_Name"></div>
                    </v-card-title>
                  </v-card>


                  <v-card class="mt-7">
                    <v-toolbar :color="appColor" dark flat>
                      <v-toolbar-title>รายชื่อผู้เข้าร่วมโครงการและลงทะเบียน ทั้งหมด
                        {{ JoinPerson.filter(item => item.status_reg_person == '1').length }} คน
                      </v-toolbar-title>
                    </v-toolbar>
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <v-text-field v-model="searchPerson" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                    </v-card-title>
                    <v-list-item>
                      <v-row class="d-flex justify-center">
                        <v-col cols="12" md="6">
                          <v-select v-model="selMenu" :items="menu" item-value="id" item-text="text">
                            <template v-slot:item="{item}">
                              <h4 class="font-weight-bold" v-if="item.id == '1'">{{item.text}}
                                <span style="color: #364eff">{{JoinPerson.length}}</span>
                                รายการ
                              </h4>
                              <h4 class="font-weight-bold" v-else-if="item.id == '2'">{{item.text}}
                                <span style="color: #364eff">{{JoinPerson.filter(itemJ => itemJ.status_reg_person ==
                                  '1').length}}</span>
                                รายการ
                              </h4>
                              <h4 class="font-weight-bold" v-else-if="item.id == '3'">{{item.text}}
                                <span style="color: #364eff">{{JoinPerson.filter(itemJ => itemJ.status_reg_person ==
                                  '0').length}}</span>
                                รายการ
                              </h4>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-data-table :headers="headersPerson"
                      :items="selMenu == '1' ? JoinPerson : selMenu == '2' ? JoinPerson.filter(itemJ => itemJ.status_reg_person == '1') : JoinPerson.filter(itemJ => itemJ.status_reg_person == '0')"
                      :search="searchPerson">
                      <template v-slot:item.type="{item}">
                        <span v-if="item.registerType_id == '0'" style="color: #ff6d81">
                          บุคลากรคณะแพทย์
                        </span>
                        <span v-if="item.registerType_id == '1'" style="color: #ff6d81">
                          นักศึกษาคณะแพทย์
                        </span>
                        <span v-if="item.registerType_id == '2'" style="color: blue">
                          บุคลากรคณะอื่น
                        </span>
                        <span v-if="item.registerType_id == '3'" style="color: blue">
                          นักศึกษาคณะอื่น
                        </span>
                        <span v-if="item.registerType_id == '4'" style="color: darkslateblue">
                          บุคคลภายนอก
                        </span>
                        <span v-if="item.registerType_id == '5'" style="color: darkslateblue">
                          นักศึกษาภายนอก
                        </span>
                      </template>
                      <template v-slot:item.action="{ item }">
                        <v-radio-group v-model="item.role" dense class="ma-0 pa-0" column>
                          <v-radio 
                            v-for="role in roleData"
                            :key="role.id"
                            :label="role.name" 
                            :value="role.id"
                            :color="randomColor(role.id)"
                            @change="updateRole(item, role.id)"
                            style="margin-bottom: -3px;"
                          ></v-radio>
                        </v-radio-group>
                      </template>
                      <template v-slot:footer>
                      <v-row class="pa-4">
                        <v-col cols="12">
                        <v-card outlined class="pa-4">
                          <v-card-title class="text-h6 justify-center">
                          สรุปจำนวนผู้เข้าร่วม
                          </v-card-title>
                          <v-row>
                          <v-col 
                            v-for="(summary, index) in getTypeSummary" 
                            :key="index"
                            cols="12" 
                            md="6" 
                            lg="4"
                          >
                            <v-card outlined class="pa-3 mb-2">
                            <div class="font-weight-bold text-center mb-2" :style="`color: ${getTypeColor(summary.type)}`">
                              {{ summary.typeName }}
                            </div>
                            <div class="text-center">
                              <span class="text-h6 font-weight-bold">{{ summary.total }}</span> คน
                            </div>
                            <div v-if="summary.roles.length > 0" class="mt-2">
                              <div 
                              v-for="role in summary.roles" 
                              :key="role.roleId"
                              class="text-caption text-center"
                              >
                              เป็น {{ role.roleName }} {{ role.count }} คน
                              </div>
                            </div>
                            </v-card>
                          </v-col>
                          </v-row>
                          <v-divider class="my-3"></v-divider>
                          <div class="text-center">
                            <v-row>
                              <v-col 
                                v-for="role in roleData" 
                                :key="role.id"
                                cols="12" 
                                :md="12 / (roleData.length + 1)"
                              >
                                <v-card outlined class="pa-2">
                                  <div class="font-weight-bold text-h6" :style="`color: ${randomColor(role.id)}`">
                                    {{ role.name }}
                                  </div>
                                  <div class="text-h5 font-weight-bold">
                                    {{ getRoleCount(role.id) }} คน
                                  </div>
                                </v-card>
                              </v-col>
                              <v-col cols="12" :md="12 / (roleData.length + 1)">
                                <v-card outlined class="pa-2">
                                  <div class="font-weight-bold text-h6" style="color: #9C27B0">รวมทั้งหมด</div>
                                  <div class="text-h5 font-weight-bold">{{ getTotalCount }} คน</div>
                                </v-card>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card>
                        </v-col>
                      </v-row>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-list-item class="d-flex justify-center mt-6">
                    <!--                  <download-excel
                                          class="btn btn-default"
                                          :data="json_data"
                                          :fields="json_fields"
                                          worksheet="รายชื่อผู้เข้าร่วมโครงการ"
                                          :name="'รายชื่อผู้เข้าร่วมโครงการ ' + Project_name + '.xls'"
                                      >
                                        <v-btn outlined color="green" class="darken-3" @click="ExportData">
                                          Export รายชื่อผู้เข้าร่วมโครงการ
                                        </v-btn>
                                      </download-excel>-->
                    <v-row class="d-flex justify-center">
                      <v-col class="d-flex justify-center" cols="12" md="6">
                        <v-btn 
                          class="font-weight-bold"
                          color="green darken-3" 
                          large
                          dark
                          elevation="3"
                          rounded
                          @click="ExportData(true)"
                        >
                          <v-icon left>mdi-download</v-icon>
                          Export รายชื่อผู้เข้าร่วมโครงการ (ใหม่)
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex justify-center" cols="12" md="6">
                        <v-btn 
                          class="font-weight-bold"
                          color="green darken-3" 
                          large
                          dark
                          elevation="3"
                          rounded
                          @click="ExportData(false)"
                        >
                          <v-icon left>mdi-file-document</v-icon>
                          Export รายชื่อผู้เข้าร่วมโครงการ (สำเนา)
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item>
                  <!--                <div v-html="html_data"></div>-->
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-dialog v-model="dialogLoading" persistent width="300">
        <v-card :color="appColor" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>

<script>
import axios from "axios";
import ConstData from "../../const/Const";
import {mapActions, mapGetters} from "vuex";
import Vue from "vue";
// import { random } from "core-js/core/number";

export default {
  name: "ExportListData",
  data() {
    return {
      getTypeSummary: [],
      getTotalCount: 0,
      roleData: [],
      joinProjectTypeData: [],
      FiscalYear: null,
      FiscalYearDataSel: [],
      selMenu: '1',
      menu: [
        {text: 'ทั้งหมด', id: '1'},
        {text: 'ลงทะเบียน', id: '2'},
        {text: 'ไม่ลงทะเบียน', id: '3'},
      ],
      TypeInsertProject: '1',
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      html_data: '',
      json_fields: {
        'ลำดับ': 'index',
        "รหัสบุคลากร/นักศึกษา/อ้างอิงบุคคลภายนอก": 'uid',
        "ชื่อ - สกุล": 'full_Name',
        "สังกัด": 'affiliation',
        "ประเภท": 'type_details',
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      projectRegDataDump: [],
      Project_code_reg: '',
      dateReg: '',
      time_start: '',
      time_end: '',
      round: '',
      round_name: '',
      dialog_create: false,
      dialog_create_confirm: false,
      dialogLoading: false,
      ShowAlertSuc: false,
      MessageSuc: '',
      ShowAlertErr: false,
      MessageError: '',
      phoneOther: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      projectDataToTable: [],
      studentData: [],
      studentUniData: [],
      IdDepartStd: '',
      IdDepart: '',
      Idstudent: '',
      IdstudentUni: '',
      IdPersonal: '',
      personalMedData: [],
      AllDepartData: [],
      project: null,
      cardSel: '',
      staffSel: '',
      NameP: '',
      items: [],
      SurNameP: '',
      affiliation: '',
      position: '',
      idCard: '',
      NameStd: '',
      SurNameStd: '',
      affiliationStd: '',
      idCardStd: '',
      departSel: null,
      EmpData: [],
      TypeInsert: '0',
      open: [1, 2],
      isLoading: false,
      tree: [],
      types: [],
      Details: true,
      FileProject: [],
      alert: false,
      txtAlert: [],
      tab: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 5,
      vertical: false,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      Project_Choose: '',
      ProjectData: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '',
      CalCredit: '',
      PLACE: '',
      Province_id: '',
      Status: '',
      Remarks: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        Project_group: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ประเภท', value: 'type'},
        {text: 'บทบาท/หน้าที่', value: 'action'}
      ],
      JoinPerson: [],
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'}
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'ระดับ', value: 'Level'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ภายในประเทศ'
        },
        {
          id: '4', detail: 'ต่างประเทศ'
        },
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      courseHeaders: [
        {text: 'โครงการ', value: 'full_Name'},
        /* {text: 'รอบที่', value: 'round'},
        {text: 'ชื่อรอบ / รุ่น', value: 'round_name'}, */
        {text: 'วันที่เริ่มต้น', value: 'dateReg'},
        {text: 'วันที่สิ้นสุด', value: 'dateEndReg'},
        {text: 'เวลาเริ่ม', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
        {text: '', value: 'Project_Details'}
      ],
    }
  },
  computed: {
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      projectRegData: 'Project/getProjectReg',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      ProjectExport: 'Project/getProjectExport',
      Role: 'Project/getRole',
      JoinProjectType: 'Project/getJoinProjectType',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      SubMenuPermiss: 'Permission/getSubMenuPermiss',
      IgnoreSubMenuPermiss: 'Permission/getIgnoreSubMenuPermiss',
      PermissionAdmin: 'Permission/getPermission',
      TypeProject: 'Project/getTypeProject',
      HeaderPage: 'Project/getHeaderPage',
      JoinProjectPage: 'Project/getManageProjectPage',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectRegister: 'Project/initProjectRegister',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initExportList: 'Project/initExportList',
      initJoinProject: 'Project/initJoinProject',
      initRole: 'Project/initRole',
      initJoinProjectType: 'Project/initJoinProjectType',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      getSubMenuPermissData: 'Permission/getSubMenuPermissData',
      getIgnoreSubMenuPermissData: 'Permission/getIgnoreSubMenuPermissData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      changeHeaderPage: 'Project/changeHeaderPage',
      changeJoinProjectPage: 'Project/changeManageProjectPage'
    }),
    init: function () {
      // this.initProjectRoundData().then(res => {
      //   if (res) {
          this.initProject()
      //   }
      // }).catch(reason => {
      //   if (reason) {
      //     this.initProject()
      //   }
      // })
    },
    initProject() {
      this.projectDataToTable = []
      this.projectRegDataDump = []
      // if (this.projectData.length == 0) {
      //   this.initProjectDataForApprove({
      //     query: 'Approve/1/Approve_Treasury/1'
      //   }).then(res => {
      //     if (res) {
      //       if (this.projectForApprove.length > 0) {
      //         this.projectDataToTable = this.projectForApprove.filter(item => item.Status != '2')
      //       }
      //     }
      //   })
      // }


      this.initDepartData()

      this.initPositionsData()

      if (this.staffData.length > 0) {
        this.staffData.map(item => {
          item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')'
        })
      }

      this.selProjFiscalYear()
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/stdMed/STUDENT/FAC_ID/09/STUDY_STATUS/OK/?limit=99999').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map(item => {
              this.studentData.push({
                ...item,
                fullName: 'รหัสนักศึกษา : ' + item.STUDENT_ID + ' ชื่อ-สกุล ' + item.STUD_NAME_THAI + ' ' + item.STUD_SNAME_THAI
              })
            })
          } else {
            this.studentData.push({
              ...res.data,
              fullName: 'รหัสนักศึกษา : ' + res.data[0].STUDENT_ID + ' ชื่อ-สกุล ' + res.data[0].STUD_NAME_THAI + ' ' + res.data[0].STUD_SNAME_THAI
            })
          }
        } else {
          this.studentData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/rest/v1/AllPersonal/dss_person.W_FACULTY/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.AllDepartData = res.data
          } else {
            this.AllDepartData.push(res.data)
          }
        } else {
          this.AllDepartData = []
        }
      })

    },
    CheckPermissFunc(permiss) {
      var CheckPermiss = false
      return new Promise(resolve => {
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == permiss) {
              CheckPermiss = true
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    ExportData(cordi) {
      if (cordi) {
        this.dialogLoading = true
        this.html_data = ''
        var countReg = 0
        var countNotReg = 0
        var html_content = ''
        var html_content2 = ''
        this.json_data = []

        // สรุปข้อมูลบทบาทและประเภท
        let roleSummary = {}
        let typeRoleSummary = {} // เพิ่มตัวแปรสำหรับสรุปประเภทและบทบาทรวมกัน

        if (this.JoinPerson.length > 0) {
          this.JoinPerson.map((item, idx) => {
            // หาชื่อบทบาท
            const roleInfo = this.roleData.find(role => role.id === item.role);
            const roleName = roleInfo ? roleInfo.name : 'ไม่ระบุ';

            this.json_data.push({
              ...item,
              index: idx + 1,
              full_Name: item.name + ' ' + item.sname,
              roleName: roleName
            })

            if (item.status_reg_person == '1') {
              // นับสรุปบทบาท
              if (!roleSummary[roleName]) {
                roleSummary[roleName] = 0;
              }
              roleSummary[roleName]++;

              // นับสรุปประเภทและบทบาทรวมกัน
              if (!typeRoleSummary[roleName]) {
                typeRoleSummary[roleName] = {};
              }
              if (!typeRoleSummary[roleName][item.type_details]) {
                typeRoleSummary[roleName][item.type_details] = 0;
              }
              typeRoleSummary[roleName][item.type_details]++;

                html_content += '' +
                '<tbody>' +
                '<tr>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:5%;text-align:center">' + (++countReg) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:12%;text-align:center">' + (item.uid == null ? '' : item.uid) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:25%">' + (item.name == null ? '' : item.name) + ' ' + (item.sname == null ? '' : item.sname) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:25%">' + (item.affiliation == null ? '' : item.affiliation) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:18%;text-align:center">' + (item.type_details == null ? '' : item.type_details) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:15%;text-align:center">' + (roleName == null ? '' : roleName) + '</td>' +
                '</tr>' +
                '</tbody>'
            } else {
              html_content2 += '' +
                '<tbody>' +
                '<tr>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:5%;text-align:center">' + (++countNotReg) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:12%;text-align:center">' + (item.uid == null ? '' : item.uid) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:25%">' + (item.name == null ? '' : item.name) + ' ' + (item.sname == null ? '' : item.sname) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:25%">' + (item.affiliation == null ? '' : item.affiliation) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:18%;text-align:center">' + (item.type_details == null ? '' : item.type_details) + '</td>' +
                '<td style="border:1px solid black;border-collapse: collapse;font-weight: bold;width:15%;text-align:center">' + (roleName == null ? '' : roleName) + '</td>' +
                '</tr>' +
                '</tbody>'
            }
          })

          // สร้างตารางสรุปบทบาท
          let roleSummaryTable = '<table style="border-collapse: collapse;width: 50%;margin:20px auto;">' +
            '<thead>' +
            '<tr>' +
            '<th colspan="2" style="border:1px solid black;background-color:#f0f0f0;padding:8px;font-weight:bold;text-align:center">สรุปจำนวนผู้ลงทะเบียนตามบทบาท/หน้าที่</th>' +
            '</tr>' +
            '<tr>' +
            '<th style="border:1px solid black;background-color:#f8f8f8;padding:5px;font-weight:bold;text-align:center;width:70%">บทบาท/หน้าที่</th>' +
            '<th style="border:1px solid black;background-color:#f8f8f8;padding:5px;font-weight:bold;text-align:center;width:30%">จำนวน (คน)</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>';

          let totalRoleCount = 0;
          Object.keys(roleSummary).forEach(role => {
            totalRoleCount += roleSummary[role];
            roleSummaryTable += '<tr>' +
              '<td style="border:1px solid black;padding:5px;text-align:left">' + role + '</td>' +
              '<td style="border:1px solid black;padding:5px;text-align:center">' + roleSummary[role] + '</td>' +
              '</tr>';
          });

          // เพิ่มแถวรวมทั้งสิ้น
          roleSummaryTable += '<tr style="background-color:#e8f5e8;">' +
            '<td style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;">รวมทั้งสิ้น</td>' +
            '<td style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;color:green;">' + totalRoleCount + ' คน</td>' +
            '</tr>';

          roleSummaryTable += '</tbody></table>';

          // สร้างตารางสรุปประเภทและบทบาท (เรียงผู้เข้าร่วมก่อน)
          let typeRoleSummaryTable = '<table style="border-collapse: collapse;width: 80%;margin:20px auto;">' +
            '<thead>' +
            '<tr>' +
            '<th colspan="3" style="border:1px solid black;background-color:#f0f0f0;padding:8px;font-weight:bold;text-align:center">สรุปจำนวนผู้ลงทะเบียนตามประเภทผู้เข้าร่วม</th>' +
            '</tr>' +
            '<tr>' +
            '<th style="border:1px solid black;background-color:#f8f8f8;padding:5px;font-weight:bold;text-align:center;width:40%">บทบาท/หน้าที่</th>' +
            '<th style="border:1px solid black;background-color:#f8f8f8;padding:5px;font-weight:bold;text-align:center;width:40%">ประเภท</th>' +
            '<th style="border:1px solid black;background-color:#f8f8f8;padding:5px;font-weight:bold;text-align:center;width:20%">จำนวน (คน)</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>';

          let totalTypeRoleCount = 0;

          // เรียงลำดับโดยให้ "ผู้เข้าร่วม" อยู่บนสุด
          const sortedRoles = Object.keys(typeRoleSummary).sort((a, b) => {
            if (a === 'ผู้เข้าร่วม') return -1;
            if (b === 'ผู้เข้าร่วม') return 1;
            return a.localeCompare(b);
          });

          // // สร้างลำดับการเรียงตามประเภท
          // const typeOrder = {
          // 'นักศึกษาภายนอก': 1,
          // 'นักศึกษาภายในคณะ': 2,
          // 'นักศึกษาภายในมหาวิทยาลัย': 3,
          // 'บุคคลภายนอก': 4,
          // 'บุคลากรภายในคณะ': 5,
          // 'บุคลากรภายในมหาวิทยาลัย': 6
          // };

          const typeOrder2 = [
            'นักศึกษาภายนอก',
            'นักศึกษาภายในคณะ',
            'นักศึกษาภายในมหาวิทยาลัย',
            'บุคคลภายนอก',
            'บุคลากรภายในคณะ',
            'บุคลากรภายในมหาวิทยาลัย'
          ];

          // เก็บประเภทที่แสดงแล้ว
          const displayedTypes = new Set();
          // เช็ค type ที่ไม่มีข้อมูลและใส่จำนวนเป็น 0
          let lastDisplayedRole = '';

          typeOrder2.forEach((type) => {
            let hasData = false;
            // let typeDisplayCount = 0;

            // เช็คว่า type นี้มีข้อมูลใน role ใดบ้าง
            sortedRoles.forEach(role => {
              if (typeRoleSummary[role] && typeRoleSummary[role][type] && typeRoleSummary[role][type] > 0) {
                hasData = true;
                const count = typeRoleSummary[role][type];
                const isLecturerOrCommittee = role === 'วิทยากร' || role === 'กรรมการและผู้จัด';

                if (!displayedTypes.has(type)) {
                  if (isLecturerOrCommittee) {
                    const roleToDisplay = (lastDisplayedRole === role) ? '' : (isLecturerOrCommittee ? '' : role);
                     typeRoleSummaryTable += '<tr>' +
                        '<td style="border:1px solid black;padding:5px;text-align:left">' + roleToDisplay + '</td>' +
                        '<td style="border:1px solid black;padding:5px;text-align:left"> - ' + type + '</td>' +
                        '<td style="border:1px solid black;padding:5px;text-align:center">0</td>' +
                        '</tr>';

                    // อัพเดต lastDisplayedRole หากมีการแสดง role
                    if (roleToDisplay !== '' && !isLecturerOrCommittee) {
                      lastDisplayedRole = role;
                    }
  

                      // เพิ่ม type ลงใน displayedTypes
                      displayedTypes.add(type);
                  } else {
                    // totalTypeRoleCount += count;
  
                    // เช็คว่า role เหมือนกับที่แสดงก่อนหน้าหรือไม่
                    const roleToDisplay = (lastDisplayedRole === role) ? '' : (isLecturerOrCommittee ? '' : role);
                    
                    typeRoleSummaryTable += '<tr>' +
                      '<td style="border:1px solid black;padding:5px;text-align:left">' + roleToDisplay + '</td>' +
                      '<td style="border:1px solid black;padding:5px;text-align:left"> - ' + type + '</td>' +
                      '<td style="border:1px solid black;padding:5px;text-align:center">' + count + '</td>' +
                      '</tr>';
                      
                      // อัพเดต lastDisplayedRole หากมีการแสดง role
                      if (roleToDisplay !== '' && !isLecturerOrCommittee) {
                        lastDisplayedRole = role;
                      }
                      
                      // เพิ่ม type ลงใน displayedTypes
                      displayedTypes.add(type);
                      // typeDisplayCount++;
                  }
                } else {
                  if (!isLecturerOrCommittee) {
                    // totalTypeRoleCount += count;
                    // อัพเดตจำนวนคนสำหรับ type ที่มีอยู่แล้ว
                    const existingRowPattern = new RegExp('( - ' + type.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '.*?<td[^>]*>)([0-9]+)(</td>)');
                    const match = typeRoleSummaryTable.match(existingRowPattern);
                    if (match) {
                      const currentCount = parseInt(match[2]);
                      const newCount = currentCount + count;
                      typeRoleSummaryTable = typeRoleSummaryTable.replace(existingRowPattern, '$1' + newCount + '$3');
                    }
                  }
                }
              }
            });
            
            // หาก type นี้ไม่มีข้อมูลเลย และยังไม่เคยแสดงใน table ให้ใส่จำนวน 0
            if (!hasData && !displayedTypes.has(type)) {

              const roleToDisplay = (lastDisplayedRole === 'ผู้เข้าร่วม') ? '' : 'ผู้เข้าร่วม';

              typeRoleSummaryTable += '<tr>' +
                '<td style="border:1px solid black;padding:5px;text-align:left">' + roleToDisplay + '</td>' +
                '<td style="border:1px solid black;padding:5px;text-align:left"> - ' + type + '</td>' +
                '<td style="border:1px solid black;padding:5px;text-align:center">0</td>' +
                '</tr>';

              lastDisplayedRole = 'ผู้เข้าร่วม'; // อัพเดต lastDisplayedRole ให้เป็น "ผู้เข้าร่วม" เมื่อไม่มีข้อมูล
              // เพิ่ม type ลงใน displayedTypes
              displayedTypes.add(type);
            }
          });

          sortedRoles.forEach(role => {
            const typeKeys = Object.keys(typeRoleSummary[role]);

            // เช็คว่าเป็นวิทยากรหรือกรรมการหรือไม่
            const isLecturerOrCommittee = role === 'วิทยากร' || role === 'กรรมการและผู้จัด';

            if (isLecturerOrCommittee) {
              // นับจำนวนรวมของบทบาทนี้ก่อน
              let roleTotal = 0;

              // totalTypeRoleCount++
              // นับจำนวนรวมของบทบาทนี้
              typeKeys.forEach((type) => {
                roleTotal += typeRoleSummary[role][type];
              });

              // แสดงผลแถวเดียวสำหรับบทบาทนี้
              typeRoleSummaryTable += '<tr>' +
                '<td style="border:1px solid black;padding:5px;text-align:left">' + role + '</td>' +
                '<td style="border:1px solid black;padding:5px;text-align:left"></td>' +
                '<td style="border:1px solid black;padding:5px;text-align:center">' + roleTotal + '</td>' +
                '</tr>';
            }
          });

          Object.values(typeRoleSummary).forEach((role) => {
            // นำจำนวนรวมของบทบาทนี้มารวม
            const typeKeys = Object.keys(role);
            let roleTotal = 0;
            typeKeys.forEach((type) => {
              roleTotal += role[type];
            });
            totalTypeRoleCount += roleTotal;
          });

          // เพิ่มแถวรวมทั้งสิ้น
          typeRoleSummaryTable += '<tr style="background-color:#e8f5e8;">' +
            '<td colspan="2" style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;">รวมทั้งสิ้น</td>' +
            '<td style="border:1px solid black;padding:8px;text-align:center;font-weight:bold;color:green;">' + totalTypeRoleCount + ' คน</td>' +
            '</tr>';

          typeRoleSummaryTable += '</tbody></table>';

          // สร้างหน้าแรก - รายชื่อผู้ลงทะเบียน
          this.html_data = '' +
            '<div>' +
            '<table style="border-collapse: collapse;width: 100%">' +
            '<thead>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><h2 style="text-align: center;font-weight: bold;">' + this.project.Project_name + ' (' + this.project.Project_code + ')</h2></th>' +
            '</tr>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (this.project.IsRoundStatus == '1' ? (this.project.DateS == this.project.DateE ? Vue.filter('DateToThai')(this.project.DateS) : Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE)) :
              (this.project.DateStart == this.project.DateEnd ? Vue.filter('DateToThai')(this.project.DateStart) : Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))) + '</p></th>' +
            '</tr>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่ลงทะเบียน ' +
            (() => {
              // Helper for Thai date
              function thaiMonth(month) {
                const months = [
                  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                ];
                return months[month - 1];
              }
              function padTime(t) {
                return t.toString().padStart(2, '0');
              }
              function formatTime(time) {
                if (!time || time === '00:00:00') return '';
                const [h, m] = time.split(':');
                return padTime(h) + '.' + padTime(m);
              }
              // Parse date
              const dateReg = this.project.dateReg;
              const dateEndReg = this.project.dateEndReg;
              let dateStr = '';
              if (!dateEndReg || dateEndReg === '' || dateEndReg === null || dateEndReg === dateReg) {
                // วันเดียวกัน
                const d = new Date(dateReg);
                dateStr = d.getDate() + ' ' + thaiMonth(d.getMonth() + 1) + ' ' + (d.getFullYear() + 543);
              } else {
                const d1 = new Date(dateReg);
                const d2 = new Date(dateEndReg);
                if (
                  d1.getFullYear() === d2.getFullYear() &&
                  d1.getMonth() === d2.getMonth()
                ) {
                  // เดือนเดียวกัน
                  dateStr = d1.getDate() + ' - ' + d2.getDate() + ' ' + thaiMonth(d1.getMonth() + 1) + ' ' + (d1.getFullYear() + 543);
                } else {
                  // คนละเดือน/ปี
                  dateStr =
                    d1.getDate() + ' ' + thaiMonth(d1.getMonth() + 1) + ' ' + (d1.getFullYear() + 543) +
                    ' - ' +
                    d2.getDate() + ' ' + thaiMonth(d2.getMonth() + 1) + ' ' + (d2.getFullYear() + 543);
                }
              }
              // เวลา
              let timeStr = '';
              const tStart = this.project.time_start;
              const tEnd = this.project.time_end;
              if (tStart && tStart !== '00:00:00') {
                if (tEnd && tEnd !== '00:00:00' && tStart !== tEnd) {
                  timeStr = formatTime(tStart) + ' - ' + formatTime(tEnd) + ' น.';
                } else {
                  timeStr = formatTime(tStart) + ' น.';
                }
              }
              return 'วันที่ ' + dateStr + (timeStr ? ' เวลา ' + timeStr : '');
            })() +
            '</p></th>' +
            '</tr>' +
            '<tr style="margin-bottom: 20px">' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + this.project.Location + '</p></th>' +
            '</tr>' +
            '<tr>' +
            '<br>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">รายชื่อผู้ลงทะเบียนเข้าร่วม</p></th>' +
            '</tr>' +
            '<tr>' +
            '<br>' +
            '<th style="border:1px solid black;border-collapse: collapse;width:5%;background-color:#f8f8f8;padding:5px">#</th>' +
            '<th style="border:1px solid black;border-collapse: collapse;width:12%;background-color:#f8f8f8;padding:5px">รหัสอ้างอิง</th>' +
            '<th style="border:1px solid black;border-collapse: collapse;width:25%;background-color:#f8f8f8;padding:5px">ชื่อ - สกุล</th>' +
            '<th style="border:1px solid black;border-collapse: collapse;width:25%;background-color:#f8f8f8;padding:5px">สังกัด</th>' +
            '<th style="border:1px solid black;border-collapse: collapse;width:18%;background-color:#f8f8f8;padding:5px">ประเภท</th>' +
            '<th style="border:1px solid black;border-collapse: collapse;width:15%;background-color:#f8f8f8;padding:5px">บทบาท/หน้าที่</th>' +
            '</tr>' +
            '</thead>' +
            html_content +
            '</table>';

          // เพิ่มหน้าผู้ไม่ลงทะเบียน หากมีข้อมูล
          if (countNotReg > 0) {
            this.html_data += '<div style="page-break-before: always;"></div>' +
              '<table style="border-collapse: collapse;width: 100%">' +
              '<thead>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><h2 style="text-align: center;font-weight: bold;">' + this.project.Project_name + ' (' + this.project.Project_code + ')</h2></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่จัด ' + (this.project.IsRoundStatus == '1' ? (this.project.DateS == this.project.DateE ? Vue.filter('DateToThai')(this.project.DateS) : Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE)) :
                (this.project.DateStart == this.project.DateEnd ? Vue.filter('DateToThai')(this.project.DateStart) : Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))) + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">วันที่ลงทะเบียน ' +
              (() => {
                // Helper for Thai month
                function thaiMonth(month) {
                  const months = [
                    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                  ];
                  return months[month - 1];
                }
                function padTime(t) {
                  return t.toString().padStart(2, '0');
                }
                function formatTime(time) {
                  if (!time || time === '00:00:00') return '';
                  const [h, m] = time.split(':');
                  return padTime(h) + '.' + padTime(m);
                }
                // Parse date
                const dateReg = this.project.dateReg;
                const dateEndReg = this.project.dateEndReg;
                let dateStr = '';
                if (!dateEndReg || dateEndReg === '' || dateEndReg === null || dateEndReg === dateReg) {
                  // วันเดียวกัน
                  const d = new Date(dateReg);
                  dateStr = d.getDate() + ' ' + thaiMonth(d.getMonth() + 1) + ' ' + (d.getFullYear() + 543);
                } else {
                  const d1 = new Date(dateReg);
                  const d2 = new Date(dateEndReg);
                  if (
                    d1.getFullYear() === d2.getFullYear() &&
                    d1.getMonth() === d2.getMonth()
                  ) {
                    // เดือนเดียวกัน
                    dateStr = d1.getDate() + ' - ' + d2.getDate() + ' ' + thaiMonth(d1.getMonth() + 1) + ' ' + (d1.getFullYear() + 543);
                  } else {
                    // คนละเดือน/ปี
                    dateStr =
                      d1.getDate() + ' ' + thaiMonth(d1.getMonth() + 1) + ' ' + (d1.getFullYear() + 543) +
                      ' - ' +
                      d2.getDate() + ' ' + thaiMonth(d2.getMonth() + 1) + ' ' + (d2.getFullYear() + 543);
                  }
                }
                // เวลา
                let timeStr = '';
                const tStart = this.project.time_start;
                const tEnd = this.project.time_end;
                if (tStart && tStart !== '00:00:00') {
                  if (tEnd && tEnd !== '00:00:00' && tStart !== tEnd) {
                    timeStr = formatTime(tStart) + ' - ' + formatTime(tEnd) + ' น.';
                  } else {
                    timeStr = formatTime(tStart) + ' น.';
                  }
                }
                return 'วันที่ ' + dateStr + (timeStr ? ' เวลา ' + timeStr : '');
              })() +
              '</p></th>' +
              '</tr>' +
              '<tr style="margin-bottom: 20px">' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">สถานที่จัด ' + this.project.Location + '</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th border="0" cellpadding="0" cellspacing="0" colspan="6"><p style="text-align: center;font-weight: bold;font-size: 16px">รายชื่อผู้ไม่ได้ลงทะเบียนเข้าร่วม</p></th>' +
              '</tr>' +
              '<tr>' +
              '<br>' +
              '<th style="border:1px solid black;border-collapse: collapse;width:5%;background-color:#f8f8f8;padding:5px">ลำดับ</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;width:12%;background-color:#f8f8f8;padding:5px">รหัสอ้างอิง</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;width:25%;background-color:#f8f8f8;padding:5px">ชื่อ - สกุล</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;width:25%;background-color:#f8f8f8;padding:5px">สังกัด</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;width:18%;background-color:#f8f8f8;padding:5px">ประเภท</th>' +
              '<th style="border:1px solid black;border-collapse: collapse;width:15%;background-color:#f8f8f8;padding:5px">บทบาท/หน้าที่</th>' +
              '</tr>' +
              '</thead>' +
              html_content2 +
              '</table>';
          }

          // เพิ่มหน้าสรุป
          this.html_data += '<div style="page-break-before: always;"></div>' +
            '<table style="border-collapse: collapse;width: 100%">' +
            '<thead>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="2"><h2 style="text-align: center;font-weight: bold;">สรุปข้อมูลผู้เข้าร่วมโครงการ</h2></th>' +
            '</tr>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="2"><h3 style="text-align: center;font-weight: bold;">' + this.project.Project_name + ' (' + this.project.Project_code + ')</h3></th>' +
            '</tr>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="2"><p style="text-align: center;font-weight: bold;font-size: 16px;">วันที่จัด ' + (this.project.IsRoundStatus == '1' ? (this.project.DateS == this.project.DateE ? Vue.filter('DateToThai')(this.project.DateS) : Vue.filter('DateToThai')(this.project.DateS) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateE)) :
              (this.project.DateStart == this.project.DateEnd ? Vue.filter('DateToThai')(this.project.DateStart) : Vue.filter('DateToThai')(this.project.DateStart) + ' ถึง ' + Vue.filter('DateToThai')(this.project.DateEnd))) + '</p></th>' +
            '</tr>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="2"><p style="text-align: center;font-weight: bold;font-size: 16px;">วันที่ลงทะเบียน ' +
            (() => {
              // Helper for Thai month
              function thaiMonth(month) {
                const months = [
                  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                ];
                return months[month - 1];
              }
              function padTime(t) {
                return t.toString().padStart(2, '0');
              }
              function formatTime(time) {
                if (!time || time === '00:00:00') return '';
                const [h, m] = time.split(':');
                return padTime(h) + '.' + padTime(m);
              }
              // Parse date
              const dateReg = this.project.dateReg;
              const dateEndReg = this.project.dateEndReg;
              let dateStr = '';
              if (!dateEndReg || dateEndReg === '' || dateEndReg === null || dateEndReg === dateReg) {
                // วันเดียวกัน
                const d = new Date(dateReg);
                dateStr = d.getDate() + ' ' + thaiMonth(d.getMonth() + 1) + ' ' + (d.getFullYear() + 543);
              } else {
                const d1 = new Date(dateReg);
                const d2 = new Date(dateEndReg);
                if (
                  d1.getFullYear() === d2.getFullYear() &&
                  d1.getMonth() === d2.getMonth()
                ) {
                  // เดือนเดียวกัน
                  dateStr = d1.getDate() + ' - ' + d2.getDate() + ' ' + thaiMonth(d1.getMonth() + 1) + ' ' + (d1.getFullYear() + 543);
                } else {
                  // คนละเดือน/ปี
                  dateStr =
                    d1.getDate() + ' ' + thaiMonth(d1.getMonth() + 1) + ' ' + (d1.getFullYear() + 543) +
                    ' - ' +
                    d2.getDate() + ' ' + thaiMonth(d2.getMonth() + 1) + ' ' + (d2.getFullYear() + 543);
                }
              }
              // เวลา
              let timeStr = '';
              const tStart = this.project.time_start;
              const tEnd = this.project.time_end;
              if (tStart && tStart !== '00:00:00') {
                if (tEnd && tEnd !== '00:00:00' && tStart !== tEnd) {
                  timeStr = formatTime(tStart) + ' - ' + formatTime(tEnd) + ' น.';
                } else {
                  timeStr = formatTime(tStart) + ' น.';
                }
              }
              return 'วันที่ ' + dateStr + (timeStr ? ' เวลา ' + timeStr : '');
            })() +
            '</p></th>' +
            '</tr>' +
            '<tr>' +
            '<th border="0" cellpadding="0" cellspacing="0" colspan="2"><p style="text-align: center;font-weight: bold;font-size: 16px;">สถานที่จัด ' + this.project.Location + '</p></th>' +
            '</tr>' +
            '<tr style="height: 40px;"><th colspan="2"></th></tr>' +
            '</thead>' +
            '</table>' +
            '<div style="text-align: center; margin: 20px 0;">' +
            typeRoleSummaryTable +
            '</div>' +
            '<div style="text-align: center; margin: 20px 0;">' +
            roleSummaryTable +
            '</div>' +
            '<table style="border-collapse: collapse;width: 100%">' +
            '<tbody>' +
            '<tr><td style="height: 20px;"></td></tr>' +
            '</tbody>' +
            '</table>' +
            '<div style="margin: 15px 0; text-align: center;">' +
            '<table style="border-collapse: collapse; width: 70%; margin: 0 auto; border: 2px solid black;">' +
            '<thead>' +
            '<tr>' +
            '<th colspan="3" style="border: 1px solid black; background-color: #e0e0e0; padding: 12px; font-weight: bold; font-size: 18px;">สรุปภาพรวมผู้เข้าร่วมโครงการ</th>' +
            '</tr>' +
            '</thead>' +
            '<tbody>' +
            '<tr>' +
            '<td style="border: 1px solid black; padding: 10px; font-weight: bold; background-color: #f5f5f5;">รายชื่อผู้สมัครเข้าร่วมทั้งหมด</td>' +
            '<td style="border: 1px solid black; padding: 10px; text-align: center; font-size: 16px; font-weight: bold;">' + this.JoinPerson.length + ' คน</td>' +
            '<td style="border: 1px solid black; padding: 10px; text-align: center; background-color: #f0f8ff;">100%</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="border: 1px solid black; padding: 10px; font-weight: bold; background-color: #e8f5e8;">มีการลงทะเบียน</td>' +
            '<td style="border: 1px solid black; padding: 10px; text-align: center; font-size: 16px; font-weight: bold; color: green;">' + this.JoinPerson.filter(item => item.status_reg_person == '1').length + ' คน</td>' +
            '<td style="border: 1px solid black; padding: 10px; text-align: center; color: green; font-weight: bold;">' + Math.round((this.JoinPerson.filter(item => item.status_reg_person == '1').length / this.JoinPerson.length) * 100) + '%</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="border: 1px solid black; padding: 10px; font-weight: bold; background-color: #ffeaea;">ไม่ลงทะเบียน</td>' +
            '<td style="border: 1px solid black; padding: 10px; text-align: center; font-size: 16px; font-weight: bold; color: red;">' + this.JoinPerson.filter(item => item.status_reg_person == '0').length + ' คน</td>' +
            '<td style="border: 1px solid black; padding: 10px; text-align: center; color: red; font-weight: bold;">' + Math.round((this.JoinPerson.filter(item => item.status_reg_person == '0').length / this.JoinPerson.length) * 100) + '%</td>' +
            '</tr>' +
            '</tbody>' +
            '</table>' +
            '</div>' +
            '<div></div>' +
            '<table style="width: 100%; margin-top: 120px;">' +
            '<tr>' +
            '<td style="width: 50%;"></td>' +
            '<td style="width: 50%; text-align: center;">' +
            '<p style="font-weight: bold; margin-bottom: 60px;">(..........................................................)</p>' +
            '<p style="font-weight: bold; margin-bottom: 10px;">(..........................................................)</p>' +
            '<p style="font-weight: bold;">ผู้รับรอง</p>' +
            '</td>' +
            '</tr>' +
            '</table>' +
            '</div>'

          axios.post(ConstData.ConnectionHost + '/HrTrain2/Export2_QR.php', {
            Project_code: this.project.Project_code,
            title: this.project.Project_name,
            subject: this.project.Project_name,
            author: "",
            type: "1",
            id_Ref: this.project.Project_code,
            round_Ref: (this.project.IsRoundStatus == '0' ? null : this.project.Ref_id),
            D_Project_Register_id: this.project.D_Project_Register_id,
            perid: this.MeData[0].perid,
            html_data: this.html_data,
          }, {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(res => {
            if (res.data.status) {
              this.dialogLoading = false
              window.open(ConstData.ConnectionHost + '/HrTrain2/GetFileReport.php?file_name=' + res.data.path, '_blank');
            } else {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ โปรดลองอีกครั้ง หรือ ติดต่อผู้ดูแลระบบ'
              })
            }
          }).catch(res => {
            if (res) {
              this.dialogLoading = false
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่สามารถดาวน์โหลดรายชื่อได้ โปรดลองอีกครั้ง หรือ ติดต่อผู้ดูแลระบบ'
              })
            }
          })
        } else {
          this.dialogLoading = false
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่พบรายชื่อผู้ลงทะเบียนเข้าร่วม'
          })
        }
      } else {
        this.dialogLoading = true
        var urlPath = (this.project.IsRoundStatus == '0' ? ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_report/D_Project_Register_id/' + this.project.D_Project_Register_id + '/active/1/?sort=id_DESC&limit=1' :
          ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_report/id_Ref/' + this.project.Project_code + '/round_Ref/' + this.project.Ref_id + '/active/1/?sort=id_DESC&limit=1')
        axios.get(urlPath).then(res => {
          if (res.data) {
            this.dialogLoading = false
            window.open(ConstData.ConnectionHost + '/HrTrain2/GetFileReport.php?file_name=' + res.data.file_name, '_blank');
          } else {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด ไม่พบข้อมูลสำเนารายชื่อ ผู้เข้าร่วมโครงการ!!'
            })
          }
        })
      }
    },
    showDetails: function (item) {
      if (this.Details_Cordi) {
        this.project = null
        this.Details_Cordi = false
      } else {
        this.project = item
        this.Details_Cordi = true;
        this.JoinPerson = []
        var url = ''
        this.Project_name = ''
        this.Project_name = item.full_Name
        this.selMenu = '1'
        this.initJoinProject({
          Project_code: item.Project_code
        }).then(resJoin => {
          if (resJoin) {
            if (item.IsRoundStatus == '0') {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project_view/Project_code/' + item.Project_code + '/D_Project_Register_id/' + item.D_Project_Register_id + '/active/1/?limit=9999'
              this.JoinProject.map(Join_i => {
                this.JoinPerson.unshift({
                  ...Join_i,
                  full_Name: Join_i.name + ' ' + Join_i.sname,
                  idCard: Join_i.id_card,
                  status_reg_person: '0',
                })
              })
            } else {
              url = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/register_project_view/Project_code/' + item.Project_code + '/D_project_round_id/' + item.Ref_id + '/D_Project_Register_id/' + item.D_Project_Register_id + '/active/1/?limit=9999'
              this.JoinProject.map(Join_i => {
                if (Join_i.D_project_round_id == item.Ref_id) {
                  this.JoinPerson.unshift({
                    ...Join_i,
                    full_Name: Join_i.name + ' ' + Join_i.sname,
                    idCard: Join_i.id_card,
                    status_reg_person: '0',
                  })
                }
              })
            }
            axios.get(url).then(res => {
              if (res.data) {
                if (res.data.length > 0) {
                  this.JoinPerson.map(Join_i => {
                    res.data.map((item) => {
                      if (Join_i.uid == item.uid) {
                        Join_i.status_reg_person = item.status_reg_person
                      }
                    })
                  })
                } else {
                  this.JoinPerson.map(Join_i => {
                    if (Join_i.uid == res.data.uid) {
                      Join_i.status_reg_person = res.data.status_reg_person
                    }
                  })
                }
                this.summaryData()
              }
              // console.log(this.JoinPerson)
              // this.JoinPerson = this.JoinPerson.filter(item => item.status_reg_person == '1')
            })
          }
        })
      }
    },
    ChangeTypeProject() {

    },
    GetDateTime() {
      var date;
      date = new Date();
      date = date.getUTCFullYear() + '-' +
          ('00' + (date.getUTCMonth() + 1)).slice(-2) + '-' +
          ('00' + date.getUTCDate()).slice(-2) + ' ' +
          ('00' + date.getUTCHours()).slice(-2) + ':' +
          ('00' + date.getUTCMinutes()).slice(-2) + ':' +
          ('00' + date.getUTCSeconds()).slice(-2);
      return date
    },
    selProjFiscalYear() {
      this.dialogLoading = true
      this.initExportList({
        permiss_check: this.MeData[0].perid,
        Project_type: this.TypeProject,
        type: 'admin',
        FiscalYear: this.FiscalYear
      }).then(resExproj => {
        if (resExproj) {
          this.projectRegDataDump = this.ProjectExport
          this.dialogLoading = false
        }
      })
    },
    randomColor(roleId) {
      const colors = ['#FF5722', '#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#607D8B', '#795548', '#E91E63'];
      return colors[roleId % colors.length] || '#000000';
    },
    updateRole(item, roleID) {
      this.dialogLoading = true;
      axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
        queryName: "updateRoleJoinPerson",
        param: Buffer.from(
          encodeURIComponent(
            JSON.stringify({
              "id": item.join_id,
              "role_id": roleID,
              "permiss_check": this.MeData[0].perid
            })
          )
        ).toString('base64')
      }).then(res => {
        if (res.data.status) {
          this.$swal.fire({
            icon: 'success',
            title: 'อัพเดตข้อมูลสำเร็จ',
            text: 'อัพเดตข้อมูลบทบาท/หน้าที่ของผู้เข้าร่วมโครงการเรียบร้อยแล้ว',
            toast: true,
            position: 'top-end',
            timer: 1500,
            showConfirmButton: false
          });
          this.summaryData();
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: res.data.message,
            confirmButtonText: 'ตกลง'
          });
        }
      }).catch(err => {
        console.error(err);
        this.$swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถอัพเดตข้อมูลบทบาท/หน้าที่ได้ กรุณาลองใหม่อีกครั้ง',
          confirmButtonText: 'ตกลง'
        });
      }).finally(() => {
        this.dialogLoading = false;
      });
    },
    summaryData() {
      const summary = {};
      let totalCount = 0;
      
      // สร้างโครงสร้างข้อมูลสรุป
      this.joinProjectTypeData.forEach(type => {
        summary[type.type_id] = {
          type: type.type_id,
          typeName: type.type_details,
          total: 0,
          roles: {}
        };
      });

      // นับจำนวนผู้เข้าร่วมตามประเภทและบทบาท
      this.JoinPerson.forEach(person => {
        const typeId = person.registerType_id;
        const roleId = person.role;
        
        if (summary[typeId]) {
          summary[typeId].total++;
          totalCount++;
          
          // หาชื่อบทบาทจาก roleData
          const roleInfo = this.roleData.find(role => role.id === roleId);
          const roleName = roleInfo ? roleInfo.name : 'ไม่ระบุ';
          
          if (!summary[typeId].roles[roleId]) {
            summary[typeId].roles[roleId] = {
              roleId: roleId,
              roleName: roleName,
              count: 0
            };
          }
          summary[typeId].roles[roleId].count++;
        }
      });

      // แปลงเป็น array และเรียงลำดับ
      this.getTypeSummary = Object.values(summary)
        .filter(item => item.total > 0)
        .map(item => ({
          ...item,
          roles: Object.values(item.roles)
        }))
        .sort((a, b) => a.type - b.type);
        
      this.getTotalCount = totalCount;
    },
    getTypeColor(typeId) {
      const colors = {
        '0': '#ff6d81', // บุคลากรคณะแพทย์
        '1': '#ff6d81', // นักศึกษาคณะแพทย์
        '2': 'blue',    // บุคลากรคณะอื่น
        '3': 'blue',    // นักศึกษาคณะอื่น
        '4': 'darkslateblue', // บุคคลภายนอก
        '5': 'darkslateblue'  // นักศึกษาภายนอก
      };
      return colors[typeId] || '#000000';
    },
    getRoleCount(roleId) {
      return this.JoinPerson.filter(item => item.role === roleId).length;
    }
  },
  mounted() {
    this.dialogLoading = true
    this.changeHeaderPage({
      page: '2'
    })
    this.changeJoinProjectPage({
      page: '0'
    })
    for (var l = 2020; l <= (new Date().getFullYear() + 3); l++) {
      this.FiscalYearDataSel.push({
        year: l,
        yearth: l + 543
      })
    }
    this.initRole().then(res => {
      if (res) {
        this.roleData = this.Role
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
    this.initJoinProjectType().then(res => {
      if (res) {
        // เก็บค่าไว้ใน local variable ก่อน
        const joinProjectTypeData = this.JoinProjectType;
        // console.log('First log:', joinProjectTypeData);
        
        // ใช้ setTimeout เพื่อดูว่าค่าเปลี่ยนเมื่อไหร่
        // setTimeout(() => {
        //   console.log('Second log:', this.JoinProjectType);
        //   console.log('Local variable:', joinProjectTypeData);
        // }, 100);
        
        // หรือ assign ให้กับ data property อื่น
        this.joinProjectTypeData = [...joinProjectTypeData]; // clone array
      }
    }).catch(reason => {
      console.log('Reject = ' + reason);
    });
    this.FiscalYear = new Date().getFullYear()
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreSubMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '10',
          page_sub_id: '10',
        })
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '7000') {
                this.getSubMenuPermissData().then(res => {
                  if (res) {
                    if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                      this.maintain = false
                      this.init()
                    } else {
                      this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                      this.maintain = true
                      this.dialogLoading = false
                    }
                  }
                }).then(err => {
                  if (err) {
                    this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                    this.maintain = true
                    this.dialogLoading = false
                  }
                })
                this.CheckAdmin = true
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.dialogLoading = false
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '7000') {
                    this.getSubMenuPermissData().then(res => {
                      if (res) {
                        if (this.SubMenuPermiss.length > 0 && this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_status == '1').length > 0 || this.IgnoreSubMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                          this.maintain = false
                          this.init()
                        } else {
                          this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                          this.maintain = true
                          this.dialogLoading = false
                        }
                      }
                    }).then(err => {
                      if (err) {
                        this.pageMessage = this.SubMenuPermiss.filter(item => item.page_sub_id == '10' && item.page_message != null).length > 0 ? this.SubMenuPermiss.filter(item => item.page_sub_id == '10')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                        this.dialogLoading = false
                      }
                    })
                    this.CheckSubAdmin = true
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.dialogLoading = false
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.dialogLoading = false
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
